import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMoment from 'vue-moment'
import store from './store'
import Vuelidate from 'vuelidate'
import VueLoading from 'vuejs-loading-plugin'
import CKEditor from '@ckeditor/ckeditor5-vue'

import Api from './api'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueSweetalert2)
Vue.use(VueMoment)
Vue.use(Vuelidate)
Vue.use(VueLoading)
Vue.use(CKEditor)

Vue.prototype.$http = Api

Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Carregando...', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['cls-loading'] // array, object or string
})

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})

Vue.prototype.$http.interceptors.response.use(response => {
  if (response.status === 401 || response.status === 403 || response.status === 419) {
    Vue.prototype.$swal({
      icon: 'error',
      title: 'Oops...',
      text: 'Acesso não autorizado!',
    })
    //console.log(router)
    // router.push({ name: 'Dashboard' })
    router.go(-1)
    this.$loading(false)
    return false
  }
  return response;
}, error => {
  return error;
});